import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadCSS } from 'fg-loadcss/src/loadCSS';
import 'typeface-roboto';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import globalConfig from 'react-global-configuration';

import { network } from './config/blockchain';
import GoogleTagManager from './components/GoogleTagManager';
import Web3Provider from './components/Web3Provider';
import NetworkCodeCheck from './components/NetworkCodeCheck';
import Routes from './routes';
import './App.css';

globalConfig.set({
  showLinkedAccounts: false
});

if (process.env.NODE_ENV !== 'production') {
  window.localStorage.setItem('debug', 'blockchain-dapp:*');
}

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#333333'
    },
    secondary: {
      main: '#9d0000'
    }
  }
});

class App extends PureComponent {
  componentDidMount() {
    loadCSS(
      'https://use.fontawesome.com/releases/v5.3.1/css/all.css',
      document.querySelector('#insertion-point-jss'),
    );
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        <GoogleTagManager gtmId="GTM-WVVCX4G" previewVariables={network.gtmEnvironment} />
        <Web3Provider>
          <NetworkCodeCheck web3={this.props.web3}/>
          <Router>
            <Routes/>
          </Router>
        </Web3Provider>
      </MuiThemeProvider>
    );
  }
};

const mapStateToProps = state => {
  return {
    web3: state.web3Reducer.web3
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js